module.exports = __webpack_public_path__ + "static/deplano-be581766bb0ae18a6f694a01aa0836a3.png";